export default __webpack_public_path__ + "static/media/club.c509b117.svg";